module.exports = __webpack_public_path__ + "static/img/4.602bfcc5.png";